const SET_USER_LANGUAGE = 'SET_USER_LANGUAGE';

export {SET_USER_LANGUAGE};

export type userLanguagePayloadType = {
    type: SET_USER_LANGUAGE,
    payload: {
        userLanguage: string,
    },
};

export type configurationReducerType = {
    userLanguage: string,
};

export type configurationActionType =
    | pageHeaderPayloadType
    | userLanguagePayloadType;

export type resetStorePayloadType = {
    type: RESET_STORE,
    payload?: any,
};
